<script setup lang="ts">
/***
 * template to show array of areas
 */
import { navigationItems } from '@/router/navigation';

import type { DataTableCellProps } from './templateTypes';
const area = `${navigationItems?.find((a) => a.name === 'areas')?.icon} sey-icon mr-1`;
const _props = defineProps<DataTableCellProps>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <div v-for="arrayValue in cell.value" :key="arrayValue.id">
      <div>
        <span :class="area"> </span>
        <RouterLink class="a-inline" :to="`/areas/${arrayValue.area.id}`">{{
          arrayValue.area.name
        }}</RouterLink>
      </div>
    </div>
  </div>
</template>
